require("dotenv").config(); //eslint-disable-line

const fr = require('./src/data/fr/index');
const en = require('./src/data/en/index');


module.exports = {
  attributes: { //  add html attributes in the firts node of the application node
    home: {
      // default home route name
      value: 'annee3',
    },
    gift___enabled: {
      value: true,
    },
    annee1___coin: {
      value: '7',
    },
    annee2___coin: {
      value: '7',
    },
    annee3___coin: {
      value: '7',
    },
    annee1___youtube: {
      value: 'Z7ARRKqMWfE',
    },
    annee2___youtube: {
      value: 'Z7ARRKqMWfE',
    },
    annee3___youtube: {
      value: 'Z7ARRKqMWfE',
    },
    external___hosting: {
      // value: 'https://mdp-orsdefrance-031264155361.s3.eu-west-1.amazonaws.com/',
      value: 'https://ddgcwrqcwtf3b.cloudfront.net/',
    },
    differ___loading: {
      value: true,
    },
    skip___frame: {
      value: true,
    },
    render___stopauto: {
      value: true,
    },
    // force___external: {
    //   value: true, // beware, boolean becomes strings
    // },
    /*
    annee2___coin: {
      value: '1',
    },
    annee2___youtube: {
      value: null,
    },
    annee3___coin: {
      value: '1',
    },
    annee3___youtube: {
      value: null,
    },
    */
    museum: {
      value: 'https://www.monnaiedeparis.fr/fr/le-lieu-culturel/musee/le-musee',
    },
  },
  // data fr and en
  fr,
  en,
  statics: ['statics'],
};
